import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import { Ticket, Trophy, Calendar, Sparkles } from "lucide-react";
import BackButton from "@/components/BackButton";

export default function Tokens() {
  const { user } = useAuth();
  const [draws, setDraws] = useState([]);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [d, s] = await Promise.all([
          api.get("/lottery/draws"),
          api.get("/dashboard/summary"),
        ]);
        setDraws(d.data.draws);
        setSummary(s.data);
      } catch {}
    })();
  }, []);

  return (
    <div className="p-4 md:p-8 space-y-6" data-testid="tokens-page">
      <div className="flex justify-end mb-4"><BackButton /></div>
      <div>
        <p className="text-xs uppercase tracking-[0.4em] text-zinc-500">Moji tokeni i lutrija</p>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-wide mt-1">
          <span className="text-neon-green">NAŠA</span> Tokeni
        </h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="nasa-card p-8 lg:col-span-2 relative overflow-hidden">
          <div className="absolute inset-0 circuit-bg opacity-20" />
          <div className="absolute inset-0 bg-black/70" />
          <div className="absolute inset-0 nasa-grid-bg opacity-50" />
          <div className="relative">
            <div className="flex items-center gap-2 text-[#22ff77] uppercase tracking-[0.4em] text-[10px]">
              <Ticket className="w-4 h-4" strokeWidth={1.5} /> Vaš trenutni saldo tokena
            </div>
            <div className="font-display text-8xl md:text-9xl font-bold text-neon-green mt-3 animate-pulse-neon" data-testid="tokens-big-count">
              {user?.tickets ?? 0}
            </div>
            <p className="text-zinc-400 text-sm mt-3 max-w-xl leading-relaxed">
              Svaki NAŠA Token vas vodi korak bliže premium nagradama — od pokrivanja
              troškova najma mašine do pristupa sistemu <span className="text-[#ff7a18]">Arbitraža PRO</span>.
              Pozovite prijatelje, gradite mrežu i ubrzajte svoj napredak!
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <StatBox icon={Sparkles} label="Tokeni iz referala" value={summary?.tickets_from_referrals ?? 0} color="#22ff77" />
          <StatBox icon={Ticket} label="Tokeni iz registracije" value={1} color="#ff7a18" />
          <StatBox icon={Trophy} label="Aktivni referali" value={summary?.active_referrals ?? 0} color="#22ff77" />
        </div>
      </div>

      <div className="nasa-card overflow-hidden">
        <div className="p-6 border-b border-white/5 flex items-center gap-2">
          <Trophy className="w-4 h-4 text-[#ff7a18]" />
          <h2 className="font-display text-xl font-semibold">Istorija izvlačenja</h2>
        </div>
        {draws.length === 0 ? (
          <div className="p-10 text-center text-zinc-500 text-sm">
            Još nije izvršeno nijedno izvlačenje. Budite spremni!
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 border-b border-white/5">
                  <th className="text-left px-6 py-3">Datum</th>
                  <th className="text-left px-6 py-3">Nagrada</th>
                  <th className="text-left px-6 py-3">Pobednik</th>
                </tr>
              </thead>
              <tbody>
                {draws.map((d) => (
                  <tr key={d.id} className="border-b border-white/5">
                    <td className="px-6 py-4 font-mono text-xs text-zinc-400">
                      <Calendar className="inline w-3 h-3 mr-2 text-zinc-600" />
                      {new Date(d.drawn_at).toLocaleString("sr-Latn-RS")}
                    </td>
                    <td className="px-6 py-4 text-[#ff7a18] font-semibold">{d.prize}</td>
                    <td className="px-6 py-4">{d.winner_name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

function StatBox({ icon: Icon, label, value, color }) {
  return (
    <div className="border border-white/10 bg-black/40 p-4 rounded-sm flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Icon className="w-4 h-4" style={{ color }} strokeWidth={1.5} />
        <span className="text-[10px] uppercase tracking-widest text-zinc-400">{label}</span>
      </div>
      <span className="font-display font-bold text-2xl" style={{ color }}>{value}</span>
    </div>
  );
}
